import React from 'react';
export function TypographyScale() {
  return <div className="space-y-8 p-8 bg-white rounded-lg border border-film-border" data-id="element-1710">
      <div className="mb-6 p-4 bg-film-cream rounded border-l-4 border-film-red" data-id="element-1711">
        <p className="text-sm text-film-gray mb-2" data-id="element-1712">
          <strong className="text-film-black" data-id="element-1713">Brand Fonts:</strong>
        </p>
        <p className="text-sm text-film-gray" data-id="element-1714">
          <span className="font-display font-bold" data-id="element-1715">Futura Extra Condensed</span>{' '}
          for headings and bold text
        </p>
        <p className="text-sm text-film-gray" data-id="element-1716">
          Helvetica Neue for body text and UI elements
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-baseline border-b border-film-border pb-4" data-id="element-1717">
        <span className="text-film-gray text-sm font-mono" data-id="element-1718">Header 1</span>
        <div className="md:col-span-3" data-id="element-1719">
          <h1 className="text-4xl font-display font-bold text-film-black tracking-tight" data-id="element-1720">
            Film Notes Brand
          </h1>
          <p className="text-xs text-film-gray mt-1" data-id="element-1721">
            Futura Extra Condensed Bold • 36px/40px • Tight Tracking
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-baseline border-b border-film-border pb-4" data-id="element-1722">
        <span className="text-film-gray text-sm font-mono" data-id="element-1723">Header 2</span>
        <div className="md:col-span-3" data-id="element-1724">
          <h2 className="text-2xl font-display font-bold text-film-black" data-id="element-1725">
            Capture Every Detail
          </h2>
          <p className="text-xs text-film-gray mt-1" data-id="element-1726">
            Futura Extra Condensed Bold • 24px/32px
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-baseline border-b border-film-border pb-4" data-id="element-1727">
        <span className="text-film-gray text-sm font-mono" data-id="element-1728">Section Label</span>
        <div className="md:col-span-3" data-id="element-1729">
          <h3 className="text-sm font-display font-bold text-film-gray uppercase tracking-wider" data-id="element-1730">
            Loaded Rolls
          </h3>
          <p className="text-xs text-film-gray mt-1" data-id="element-1731">
            Futura Extra Condensed Bold • Uppercase • Wide Tracking • 14px
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-baseline border-b border-film-border pb-4" data-id="element-1732">
        <span className="text-film-gray text-sm font-mono" data-id="element-1733">Body Large</span>
        <div className="md:col-span-3" data-id="element-1734">
          <p className="text-lg text-film-black" data-id="element-1735">
            A simple, intuitive hub for managing, tracking, and exploring your
            analog photography.
          </p>
          <p className="text-xs text-film-gray mt-1" data-id="element-1736">
            Helvetica Neue Regular • 18px/28px
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-baseline" data-id="element-1737">
        <span className="text-film-gray text-sm font-mono" data-id="element-1738">Body Small</span>
        <div className="md:col-span-3" data-id="element-1739">
          <p className="text-sm text-film-gray" data-id="element-1740">
            French humanist photographer who co-founded Magnum Photos and is
            considered a pioneer of street photography.
          </p>
          <p className="text-xs text-film-gray mt-1" data-id="element-1741">
            Helvetica Neue Regular • 14px/20px
          </p>
        </div>
      </div>
    </div>;
}